// src/pages/PricingPage.js
import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { trackEvent } from '../analytics';

const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:7071' : '';

// IMPORTANT: Replace with your actual Stripe Publishable Key
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51NyEMGILygY5j0uPgxLVo59pXP4uWERjwlXeYRrcn3m4W6jUH377vaddbcUa9kcede6tOj0oP3jkEyp8DyVdxRgU00UL4xBtLT';
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

function PricingPage() {
    const [error, setError] = useState(null);
    const [isSubscribing, setIsSubscribing] = useState(null); // Will hold the ID of the plan being subscribed to

    // These are the Price IDs from your Stripe Dashboard
    const pricingPlans = [
        {
            name: 'Compliance Guardian Pro',
            price: '$149.99',
            description: 'Compliance Guardian – subscription access for auditing, alert notifications, and compliance reports.',
            priceId: 'price_1SPh5RILygY5j0uPh6E2iIHb' // IMPORTANT: Replace with your Price ID from Stripe
        }
    ];

    const handleSubscribe = async (priceId) => {
        setIsSubscribing(priceId);
        setError(null);
        trackEvent('checkout_click', { price_id: priceId });
        
        try {
            // 1. Call your backend to create the checkout session
            const response = await fetch(`${API_BASE_URL}/api/create-checkout-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ priceId: priceId })
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || "Failed to create checkout session.");
            }
            
            const session = await response.json();
            
            // 2. Redirect to Stripe Checkout using the session ID
            const stripe = await stripePromise;
            const { error } = await stripe.redirectToCheckout({ sessionId: session.sessionId });
            
            if (error) {
                setError(error.message);
            }
        } catch (e) {
            setError(e.message);
        } finally {
            setIsSubscribing(null);
        }
    };

    return (
        <div className="pricing-page">
            <h2>Choose Your Plan</h2>
            <p>Start your compliance journey today. All plans include our powerful HIPAA audit engine.</p>
            {error && <p className="error">{error}</p>}
            <div className="pricing-container">
                {pricingPlans.map(plan => (
                    <div key={plan.name} className="pricing-plan">
                        <h3>{plan.name}</h3>
                        <div className="price">{plan.price}<span>/month</span></div>
                        <p>{plan.description}</p>
                        <button onClick={() => handleSubscribe(plan.priceId)} disabled={isSubscribing}>
                            {isSubscribing === plan.priceId ? 'Redirecting...' : 'Get Started'}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PricingPage;
